import PropertyTypeFilterDropdown from './PropertyTypeFilterDropdown';

export default PropertyTypeFilterDropdown;
